import { render, staticRenderFns } from "./buyCardRecord.vue?vue&type=template&id=2baefc92&"
import script from "./buyCardRecord.vue?vue&type=script&lang=ts&"
export * from "./buyCardRecord.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "buyCardRecord.vue"
export default component.exports